<table datatable class="table bg-white align-middle effects-table" *ngIf="!showDeterminantBuilder && !showGridRow">
	<thead>
		<tr>
			<th class="" style="width: 33%;">{{'Determinant' | translate}}</th>
			<th>{{'Message' | translate}}</th>
			<th class="text-center">{{'Hide add new button' | translate}}</th>
			<th class="cell-delete text-center">&nbsp;</th>
		</tr>
	</thead>
	<tbody>
	<tr *ngFor="let item of validations; let i = index">
		<td (click)="openDeterminantModal(item)">
			<determinant-query-readonly *ngIf="!isDeterminantEmpty(item.determinants)"
				[jsonDeterminants]="item.determinants"
				[determinantMapById]="determinantMapById"></determinant-query-readonly>
			<div class="workarea__draghere" *ngIf="isDeterminantEmpty(item.determinants)">
				<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
			</div>
		</td>
        <td>
            <div>
                <input class="form-control"
                       type="text"
                       name="workingLabel"
                       [(ngModel)]="item.customMessage"
                       (blur)="save()"
                       style="border-top-right-radius:0;border-bottom-right-radius:0;"
                />
            </div>
        </td>
        <td class="text-center">
            <div>
                <input class=""
                       type="checkbox"
                       name="disableAddingRow"
                       [(ngModel)]="item.disableAddingRow"
                       (ngModelChange)="save()"
                />
            </div>
        </td>
		<td class="text-center">
			<i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false"
			   (click)="deleteRow(i)"></i>
		</td>
	</tr>
	<tr>
		<td (click)="addNewRow(true)">
			<div class="workarea__draghere">
				<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
			</div>
		</td>
		<td colspan="3"></td>
	</tr>
	</tbody>
</table>

<!-- determinant window
<div class="row layer sub-layer mt-0" id="detFromFormio"
	 [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}"
	 *ngIf="showDeterminantBuilder">
	<layer-header (closeLayer)="closeDeterminantLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
				  [listIcons]=false title="{{'Apply determinant' | translate}}" [customClass]="'mt-0'"
				  *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
		<ng-content></ng-content>
	</layer-header>
	<determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
					 class="row layer sub-layer onTop-sub-layer" id="newDetFromFormio" [serviceId]="serviceId"
					 [isOnSubLayer]="true"
					 [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
					 (editCancel)="closeEdit()"></determinant-new>
	<div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
		<div class="col-12">
			<div class="row">
				<determinant-builder-new [serviceId]="serviceId" [jsonString]="JSON.stringify(selectedRow.determinants)"
                                         [determinantMapById]="determinantMapById"
										 (onSave)="updateDeterminant($event);closeDeterminantLayer()"
										 (onCancel)="closeDeterminantLayer()" class="col-12">
				</determinant-builder-new>
			</div>
		</div>
	</div>
</div>
-->

<drawer [title]="'Manage determinants'"
        [contextLabel]="determinantContextLabel"
        [contextVariant]="'neutral'"
        [showHeader]="showDrawerHeader" [isClosed]="!showDeterminantBuilder" (saveEvent)="updateDeterminant($event)" [embedded]=true (closeEvent)="closeDeterminantLayer();" class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && selectedRow"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="selectedRow?.determinants"
            (builderUpdated)="temoupdateDeterminant($event)"
            [showBuilder]=true
            (cancel)="closeDeterminantLayer()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>
